import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';

/**
 * Route guard that only matches for anonymous (unauthenticated) users.
 * If the user is authenticated, the route won't match and Angular will
 * continue to the next route definition.
 */
export const anonymousGuard: CanMatchFn = () => {
    const keycloak = inject(KeycloakService);
    return !keycloak.isLoggedIn();
};
